package org.abhranilnxt.portfolio.models

enum class Section(
    val id: String,
    val title: String,
    val subtitle: String,
    val path: String
) {
    Home(
        id = "home",
        title = "Home",
        subtitle = "Welcome to my portfolio",
        path = "#home"
    ),
    About(
        id = "about",
        title = "About",
        subtitle = "Get To Know Me",
        path = "#about"
    ),
    Projects(
        id = "projects",
        title = "Projects",
        subtitle = "My Work",
        path = "#projects"
    ),
    Skills(
        id = "skills",
        title = "Skills",
        subtitle = "I'm Good At",
        path = "#skills"
    ),
    Experience(
        id = "experience",
        title = "Experience",
        subtitle = "Work Experience",
        path = "#experience"
    ),
    Contact(
        id = "contact",
        title = "Contact",
        subtitle = "Get in Touch",
        path = "#contact"
    )
}